/** A contact row with nothing typed or picked in any of its fields; its primary mark alone doesn't count. */
export function isBlankContactForm(values) {
    return Object.entries(values).every(([field, value]) => field === 'defaultFlag' || typeof value !== 'string' || value.trim() === '');
}
//# sourceMappingURL=is-blank-contact-form.js.map